import { Injectable } from '@angular/core';
import { Http, Headers, Response, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';

import { Menu } from './menu';
import { BodyService} from "../../shared/utils/body.service";
import { BaseService} from "../../shared/utils/BaseService";
import 'rxjs/add/operator/map'

@Injectable()
export class MenuService extends BaseService{

    constructor(protected http: Http,
                protected bodyService: BodyService) {
        super(http, bodyService);
    }
 
    findAll(): Observable<any>  {
        let body = JSON.stringify({});
        return this.http.post(this.rutaServidor + '/api/menues/findAll', body, this.options)
            .map(response => {
                let jsonResponse : any = response.json();
                return jsonResponse;
            })
            .catch(this.bodyService.handleError);
    }
 }


// WEBPACK FOOTER //
// ./src/app/_seguridad/_menu/menu.service.ts